import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export default css`
  .blade-is-open {
    overflow: hidden;
  }
  /* Position and sizing of burger button */
  .bm-burger-button {
    position: fixed;
    width: 36px;
    height: 30px;
    left: 36px;
    top: 36px;
  }

  /* Color/shape of burger icon bars */
  .bm-burger-bars {
    background: #373a47;
  }

  /* Color/shape of burger icon bars on hover*/
  .bm-burger-bars-hover {
    background: #a90000;
  }

  /* Position and sizing of clickable cross button */
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }

  /* Color/shape of close button cross */
  .bm-cross {
    background: #bdc3c7;
  }

  /*
Sidebar wrapper styles
Note: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases
*/
  .bm-menu-wrap {
    position: fixed;
    height: 100%;
    top: 0;

    width: 100% !important;
    min-width: 320px;

    width: 100% !important;
    max-width: 414px;

    &.is-active {
      box-shadow: -5px 0 7px -5px rgba(0, 0, 0, 0.35);
    }
  }

  /* General sidebar styles */
  .bm-menu {
    /* background: #373a47;
    padding: 2.5em 1.5em 0; */
    font-size: 1.15em;
    background: ${themeGet('colors.white')};
    /* background: #ffffff; */
  }

  /* Morph shape necessary with bubble or elastic */
  .bm-morph-shape {
    fill: #373a47;
  }

  /* Wrapper for item list */
  .bm-item-list {
    /* color: #b8b7ad;
    padding: 0.8em; */
  }

  /* Individual item */
  .bm-item {
    display: inline-block;
  }

  /* Styling of overlay */
  .bm-overlay {
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    right: 0l;
  }
`;
